<template>
  <div class="fair-survey-step fair-survey-step--wide">
    <div class="fair-survey-step__head">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <div class="fair-survey-step__grid">
      <button
        v-for="style in step.styles"
        :key="style.id"
        type="button"
        class="fair-survey-step__card"
        :class="{
          'fair-survey-step__card--selected': isStyleSelected(style.id),
        }"
        :aria-pressed="isStyleSelected(style.id)"
        @click="toggleStyle(style.id)"
      >
        <img
          class="fair-survey-step__card-media"
          :src="style.image"
          :alt="style.name"
        >
        <span class="fair-survey-step__card-label">{{ style.name }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useTasteClarificationModal } from '@/features/taste/store'
import type { TasteStep } from '@/features/taste/types/taste-config'

interface Props {
  step: TasteStep & { type: 'style_selection' }
}

const props = defineProps<Props>()
const tasteStore = useTasteClarificationModal()

const selectedStyles = computed(() => {
  const data = tasteStore.tasteModal.tasteData[props.step.id] || []
  // Миграция: если в store есть старые данные (string коды), преобразуем их в ID
  if (data.length > 0 && typeof data[0] === 'string') {
    return data.map((codeOrId: string) => {
      const style = props.step.styles.find(
        (s) => s.code === codeOrId || s.id.toString() === codeOrId
      )
      return style?.id
    }).filter((id: any) => id !== undefined)
  }
  return data
})

function isStyleSelected(styleId: number): boolean {
  return selectedStyles.value.includes(styleId)
}

function toggleStyle(styleId: number) {
  const currentStyles = [...selectedStyles.value]
  const index = currentStyles.indexOf(styleId)

  if (index > -1) {
    currentStyles.splice(index, 1)
  } else {
    currentStyles.push(styleId)
  }

  tasteStore.updateTasteData(props.step.id, currentStyles)
}

onMounted(() => {
  // Initialize with existing data if any
  if (!tasteStore.tasteModal.tasteData[props.step.id]) {
    tasteStore.updateTasteData(props.step.id, [])
  }
})
</script>
